import { render, staticRenderFns } from "./NotificationSubscribersComponent.vue?vue&type=template&id=5fb3ff16&"
import script from "./NotificationSubscribersComponent.vue?vue&type=script&lang=js&"
export * from "./NotificationSubscribersComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports